import { Dictionary } from 'underscore';

import { CERTIFICATION_INDICATOR_CATEGORY, WARNING_INDICATOR_CATEGORY } from '~src/catalog/components/labels/DataQualityType';

export function getCertificationActivityFromRowData(rowData: Dictionary<any>): boolean {
    // rowData can either have dataQualityCertifications or dataQualityIndicators of category CERTIFICATION
    const fromDQI = rowData.dataQualityIndicators?.some(
        (indicator: { category: string, isActive: boolean }) => indicator.category === CERTIFICATION_INDICATOR_CATEGORY && indicator.isActive);
    const fromDQC = rowData.dataQualityCertifications?.some((certification: { isActive: boolean }) => certification.isActive);

    return fromDQI || fromDQC;
}

export function getWarningSeverityFromRowData(rowData: Dictionary<any>): boolean | undefined {
    // rowData can either have dataQualityWarnings or dataQualityIndicators of category WARNING
    // if it returns undefined, no warnings exists, else returns highestSeverity
    const fromDQI = rowData.dataQualityIndicators?.some(
        (indicator: { category: string, isActive: boolean }) => indicator.category === WARNING_INDICATOR_CATEGORY && indicator.isActive);
    const fromDQW = rowData.dataQualityWarnings?.some((warning: { isActive: boolean }) => warning.isActive);

    // neither found in dataQualityIndicator nor dataQualityWarnings
    if (!fromDQI && !fromDQW) {return undefined; }

    const highestSeverity = fromDQI ?
    rowData.dataQualityIndicators?.some(
        (indicator: { category: string, isActive: boolean, isSevere: boolean }) => indicator.category === WARNING_INDICATOR_CATEGORY && indicator.isActive && indicator.isSevere) :
    rowData.dataQualityWarnings?.some((warning: { isActive: boolean, isSevere: boolean }) => warning.isActive && warning.isSevere);

    return highestSeverity;
}
